import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InfoWrapper = styled(Box)(() => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
}));
